import { EventEmitter, Inject, Injectable } from '@angular/core';
import { Subject, filter } from 'rxjs';
import { MsalService, MsalBroadcastService, MSAL_GUARD_CONFIG, MsalGuardConfiguration } from '@azure/msal-angular';
import { AuthenticationResult, InteractionStatus, PopupRequest, RedirectRequest, EventMessage, EventType } from '@azure/msal-browser';

@Injectable()
export class AzureService {
    public isIframe = false;
    public loginDisplay = false;
    public account = {};
    private readonly _destroying$ = new Subject<void>();   
    public onAuth: EventEmitter<any> = new EventEmitter();

    constructor(
        @Inject(MSAL_GUARD_CONFIG) public msalGuardConfig: MsalGuardConfiguration,
        public authService: MsalService,
        public msalBroadcastService: MsalBroadcastService) {     
    }


    public initialize() {   
        this.msalBroadcastService.msalSubject$
        .pipe(
            filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
        )
        .subscribe((result: EventMessage) => {
            const payload = result.payload as AuthenticationResult;
            this.authService.instance.setActiveAccount(payload.account);
            this.account = payload.account;
            this.onAuth.emit(payload.account);
        });

        this.msalBroadcastService.inProgress$
            .pipe(
                filter((status: InteractionStatus) => status === InteractionStatus.None)
            )
            .subscribe(() => {
                this.setLoginDisplay();
            })   
    }    

    public execAuth() {
        if (this.msalGuardConfig.authRequest){
            this.authService.loginRedirect({...this.msalGuardConfig.authRequest} as RedirectRequest);
        } else {
            this.authService.loginRedirect();
        } 
    }

    private setLoginDisplay() {
        this.loginDisplay = this.authService.instance.getAllAccounts().length > 0;
    }

    public destroy() {
        this._destroying$.next(undefined);
        this._destroying$.complete();        
    }
    
}

